import type { ThreadSummary } from "../../../api/threads/threadDecoders";
import type { ThreadDisplayStatus } from "../status/threadStatus";
import { useReadUpTo } from "./readMarks";

export interface ThreadRowFacts {
  readonly status: ThreadDisplayStatus;
  readonly lastEntryNumber: number;
  readonly unread: boolean;
  /** ISO 8601. */
  readonly lastActivityAt: string;
}

/**
 * A row of the Thread list: its status and unread marker come with the list line (Q-61),
 * which the project feed keeps current (Q-62), so a row reads nothing of its own.
 */
export function useThreadRowFacts(summary: ThreadSummary): ThreadRowFacts {
  const readUpTo = useReadUpTo(summary.threadId);
  return {
    status: summary.projection.display_status,
    lastEntryNumber: summary.lastEntryNumber,
    unread: readUpTo === null || readUpTo < summary.lastEntryNumber,
    lastActivityAt: summary.lastEntryAt,
  };
}
